import React from "react";
import { Col, Divider, Form, Row } from "antd";

import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";

import styles from "../pages/RentManagement/ReservationManagement.module.css";

function RentUserDetail({ user, additionalDriverMode }: { user?: Types.UserDto; additionalDriverMode?: boolean }) {
    return (
        <>
            {user && (
                <div>
                    <Row justify={"space-between"}>
                        <Col span={6}>
                            <Divider className={styles.subTitle} orientation="left">
                                <span>{additionalDriverMode ? "추가 운전자 정보" : "예약자 정보"}</span>
                            </Divider>
                        </Col>
                    </Row>
                    <Form>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="이름">
                                    <span>{user.name ? user.name : String.dash}</span>{" "}
                                </Form.Item>
                            </Col>
                            {!additionalDriverMode && (
                                <>
                                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                        <Form.Item className="searchForm" label="회사명">
                                            <span>{user.companyName ? user.companyName : String.dash}</span>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                        <Form.Item className="searchForm" label="이메일">
                                            <span>{user.email ? user.email : String.dash}</span>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                        <Form.Item className="searchForm" label="사업자등록번호">
                                            <span>{user.companyRegistrationNo ? user.companyRegistrationNo : String.dash}</span>
                                        </Form.Item>
                                    </Col>
                                </>
                            )}

                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="휴대전화번호">
                                    <span>{user.phone ? user.phone : String.dash}</span>
                                </Form.Item>
                            </Col>
                            {!additionalDriverMode && (
                                <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                    <Form.Item className="searchForm" label="주소">
                                        <span>{user.address ? user.address : String.dash}</span>
                                    </Form.Item>
                                </Col>
                            )}
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="면허종류">
                                    <span>{user.driverLicense?.licenseType ? user.driverLicense?.licenseType : String.dash}</span>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="면허번호">
                                    <span>{user.driverLicense?.licenseNumber ? user.driverLicense?.licenseNumber : String.dash}</span>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )}
        </>
    );
}

export default RentUserDetail;
